import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import * as echarts from "echarts"
import elementIcon from "./js/svgicon";
import utils from './js/utils.js'
import api from './js/api.js'
import publicData from './js/public.js'


// 处理element-plus自动导入，部分组件样式失效问题
import 'element-plus/theme-chalk/src/message.scss'
import 'element-plus/theme-chalk/src/message-box.scss'
import 'element-plus/theme-chalk/src/overlay.scss'
import ElementPlus from 'element-plus'
import zhCn from "element-plus/es/locale/lang/zh-cn";
import './style/index.scss'

import { ElMessage, ElMessageBox } from 'element-plus'

// 页面标题对应router里自定义的title
router.beforeEach(async (to, from, next) => {
    // console.log(store.state.token)
    if (to.meta.notoken) {
        // 登录页不需要 token
        next();
        return;
    }
    if (!store.state.token) {
        next({path: '/login', query: {redirect: to.path}});
        return;
    }
    // 权限校验：非超管用户只能访问有权限的路由
    const info = store.state.info || {};
    if (info.roleId !== 1) {
        // 实时刷新权限（5秒节流），菜单/角色改动即时生效
        await store.dispatch('refreshPermissions');
        const allowedUrls = store.state.allowedUrls || [];
        // 前缀匹配：/userInfo 可以匹配 /userInfo/123 等子页面
        const hasAccess = allowedUrls.some(url => to.path === url || to.path.startsWith(url + '/'));
        if (allowedUrls.length > 0 && !hasAccess) {
            // 无权限，跳转到第一个允许的页面
            const fallback = allowedUrls[0] || '/login';
            ElMessage.warning('没有访问该页面的权限');
            next({ path: fallback, replace: true });
            return;
        }
    }
    next();
})

const app = createApp(App)

app.config.globalProperties.utils = utils;
app.config.globalProperties.$public = publicData;
app.config.globalProperties.$api = api;
app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$message = ElMessage;
app.config.globalProperties.$confirm = ElMessageBox.confirm;
app.config.globalProperties.$msgbox = ElMessageBox;

app.provide("$api", api);

app.use(store).use(router).use(echarts).use(elementIcon).use(ElementPlus,{locale:zhCn}).mount('#app')
